.header {
  display: flex;
  justify-content: flex-end;
  flex: 1;
}

.actionButton {
  color: var(--tuna-palette-action-active);
  padding: 2px;
  margin: 2px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  background: none;
  border: none;
  cursor: pointer;
}

.actionButton--delete {
  color: var(--tuna-palette-error-main);
}

.svg {
  width: 16px;
  height: 16px;
}
